<template>
  <div class="d-flex justify-content-between align-items-center">
    <label :for="context.id" class="formulate-input-label">
      {{ context.label }}
    </label>
    <i
      v-if="isNeedTooltip"
      :id="`${this.context.name}-input-tooltip`"
      class="float-end input-tooltip-btn"
      :class="{
        'icon-outline_info': !hover,
        'icon-fill_info': hover,
      }"
      @mouseenter="hover = true"
      @mouseleave="hover = false"
    ></i>

    <b-tooltip
      v-if="isNeedTooltip"
      :target="`${this.context.name}-input-tooltip`"
      triggers="hover"
      placement="lefttop"
      custom-class="formulate-input-tooltip"
    >
      {{ this.context.attributes?.tooltip }}
    </b-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hover: false,
    }
  },
  computed: {
    isNeedTooltip() {
      return this.context.attributes?.tooltip
    },
  },
}
</script>
